// 近30天未出单老客户
export const OLD_HAS_NO_ORDER_30D_KEY = 'OLD_HAS_NO_ORDER_30D'
// 近30天未出单新客户
export const NO_ORDER_KEY = 'NO_ORDER'
// 近7天即将流失客户
export const LOSS_7DAY_KEY = 'LOSS_7DAY'
// 近30天即将流失客户
export const LOSS_KEY = 'LOSS'
// 近7天高潜力客户
export const POTENTIAL_7DAY_KEY = 'POTENTIAL_7DAY'
// 近30天高潜力客户
export const POTENTIAL_KEY = 'POTENTIAL'
// 近30天待开发客户
export const TO_BE_DEVELOPED_KEY = 'TO_BE_DEVELOPED'
// 近30天已出单新客户
export const NEW_HAS_ORDER_30D_KEY = 'NEW_HAS_ORDER_30D'
// 近7日分销金额增长
export const INCREASE_DISTR_SENT_AMT_7D_KEY = 'INCREASE_DISTR_SENT_AMT_7D'

export const SETTLEMENT_OPTIONS = [
    {
        label: '近30天未出单新客户',
        value: NO_ORDER_KEY,
        tip: '近30天内建立合作，且已发货的分销订单为0',
        focusKeys: ['未出单'], // 红色高亮
        sortFields: {
            name: 'sentAvgDayCnt',
        },
    },
    {
        label: '近30天未出单老客户',
        value: OLD_HAS_NO_ORDER_30D_KEY,
        tip: '近90天内建立合作，且已发货的分销订单为0',
        focusKeys: ['未出单'],
        sortFields: {
            name: 'sentAvgDayCnt',
        },
    },
    {
        label: '近7天即将流失客户',
        value: LOSS_7DAY_KEY,
        tip: '近7天内已发货的分销订单环比下降',
        focusKeys: ['即将流失'],
        sortFields: {
            name: 'distrSentChangeCnt',
        },
    },
    {
        label: '近30天即将流失客户',
        value: LOSS_KEY,
        tip: '近30天内已发货的分销订单环比下降',
        focusKeys: ['即将流失'],
        sortFields: {
            name: 'distrSentChangeCnt',
        },
    },
    {
        label: '近7天高潜力客户',
        value: POTENTIAL_7DAY_KEY,
        tip: '近7天内已发货的分销订单数≥10笔，且分销订单环比上升',
        focusKeys: ['高潜力'],
        sortFields: {
            name: 'distrSentChangeCnt',
        },
    },
    {
        label: '近30天高潜力客户',
        value: POTENTIAL_KEY,
        tip: '近30天内已发货的分销订单数≥10笔，且分销订单环比上升',
        focusKeys: ['高潜力'],
        sortFields: {
            name: 'distrSentCnt',
        },
    },
    {
        label: '近7日分销金额增长',
        value: INCREASE_DISTR_SENT_AMT_7D_KEY,
        // tip: '近7天内已发货的分销订单数≥10笔，且分销金额环比上升',
        focusKeys: ['高潜力'],
        sortFields: {
            name: 'distrSentChangeAmt',
        },
    },
    {
        label: '近30天已出单新客户',
        value: NEW_HAS_ORDER_30D_KEY,
        tip: '已筛选出近30天合作且已出单的新客，并按分销订单数倒序，可以多沟通重点服务。',
        focusKeys: ['已出单'],
        sortFields: {
            name: 'distrSentChangeCnt',
        },
    },
]

export const MY_PARTNER_OPTIONS = [
    {
        label: '待开单客户',
        value: NO_ORDER_KEY,
        tip: '近30天内建立合作，且已发货的分销订单为0',
        jumpCustomerCenterTip: '已为您筛选出【待开单客户】',
        sortFields: {
            name: 'sentAvgDayCnt',
        },
    },
    {
        label: '即将流失客户',
        value: LOSS_7DAY_KEY,
        tip: '近7天内已发货的分销订单环比下降',
        jumpCustomerCenterTip: '已为您筛选出近【即将流失客户】',
        sortFields: {
            name: 'distrSentChangeCnt',
        },
    },
    {
        label: '高潜力客户',
        value: POTENTIAL_KEY,
        tip: '近30天内已发货的分销订单数≥10笔，且分销订单环比上升',
        jumpCustomerCenterTip: '已为您筛选出【高潜力客户】',
        sortFields: {
            name: 'distrSentChangeCnt',
        },
    },
    {
        label: '未合作浏览商家',
        value: TO_BE_DEVELOPED_KEY,
        tip: '近30日内浏览小站，但尚未合作',
        jumpCustomerCenterTip: '已为您筛选出未合作浏览商家',
        cornerMarkerPic:
            'https://assets.sursung.com/activity/20241008/B0B1157E553B42789467671844FC82201728359565109.png',
    },
]
